import { checklistErrorTypes } from 'constants/checklist'
import { userTypes } from 'helpers/user'
import { getRandomElementFromArray } from 'utils/utils'

import { positions, PRE_CLASS_COPY_LIST, TILE_POSITIONS } from '../constant'

const { TEACHER, TRIBE_LEADER } = userTypes

export const getParticipantList = (participants = []) => {
    let list = []
    participants.forEach(participant => {
        let newparticipantEntity = {}
        const isTeacher = [TEACHER, TRIBE_LEADER].includes(
            participant.name.toLowerCase()
        )

        if (isTeacher) {
            newparticipantEntity = {
                ...participant,
                position: TILE_POSITIONS.CENTER,
            }
        } else {
            if (!positions.length) return
            const position = positions[0]
            newparticipantEntity = {
                ...participant,
                position,
            }
            positions.shift()
        }
        list.push(newparticipantEntity)
    })

    return list
}

export const getNoOfParticipantsText = (noOfParticipants, preClassHost) => {
    /*
     * if teacher is in the class along with 6 students, minimum number to
     * check and show the text is 8 otherwise it's 7
     */
    const minimumNoOfParticipants = preClassHost ? 8 : 7
    const showText = noOfParticipants >= minimumNoOfParticipants

    const teacherOrTribeLeaderName = preClassHost?.name
    const studentsWithTeacher = noOfParticipants - 7 // 7 -> 1 teacher and 6 students
    const students = noOfParticipants - 6 // 6 -> 6 students and no teacher

    const nobodyHasJoinedCopy = getRandomElementFromArray(PRE_CLASS_COPY_LIST)

    // if nobody has joined the class
    if (noOfParticipants === 0) return nobodyHasJoinedCopy
    // do not show any text if number of participants is less than equal 6
    if (noOfParticipants < 6) return ''
    // teacher and more than 6 students are in the class already
    if (preClassHost && showText)
        return `${teacherOrTribeLeaderName} + ${studentsWithTeacher} more`
    // if teacher has not joined and number of students is more than 6
    return showText && `+ ${students} more`
}

export const getParticipantTileSize = elementID => {
    const tile = document.getElementById(elementID)
    const tileHeight = tile?.offsetHeight
    const percent = 0.25

    // participant tile size is 25% of local participant's tile size
    const size = Math.round(tileHeight * percent)

    return size
}

export const getActiveCheckCopy = (checkType = checklistErrorTypes.DEVICE) => {
    switch (checkType) {
        case checklistErrorTypes.DEVICE:
            return 'Cheking your device...'
        case checklistErrorTypes.BROWSER:
            return 'Cheking your browser...'
        case checklistErrorTypes.NETWORK:
            return 'Cheking your connectivity...'
        case checklistErrorTypes.AUDIO_VIDEO:
            return 'Cheking your webcam & microphone...'
        default:
            return 'Setting you up...'
    }
}
